// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2GiCX","error":"Textarea_error__z4026","readonly":"Textarea_readonly__2q6y_","disabled":"Textarea_disabled__5rLkV"};